export default [
    {
        name: 'source_ip',
        sortField: 'source_ip',
        type: 'ip',
        defaultSearch: true,
        useInFilter: true,
    },
    // {
    //     name: '__slot:ip_domains',
    //     sortField: 'domains',
    //     type: 'array',
    //     dataClass: 'ral',
    //     defaultSearch: false,
    //     useInFilter: false,
    // },
    {
        name: '__slot:backdomains_ip_count',
        sortField: 'domains_count',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:backlinks_ip_count',
        sortField: 'backlinks_count',
        type: 'number',
        callback: 'humanNumber',
        // dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        // Только в фильтре: путь страницы сайта, на которую ведут ссылки (сюда ведут ссылки из пакетного анализа
        // по ссылкам в режиме URL). Корень — /
        name: 'path',
        type: 'string',
        visible: false,
        defaultSearch: false,
        useInFilter: true,
    },
]
